<!-- 素材审核记录-弹框组件 -->
<template>
  <div>
    <a-modal
      v-model="visible"
      title="素材审核记录"
      :width="800"
      :maskClosable="false"
      :afterClose="afterClose"
    >
      <a-spin :spinning="loading">
        <div v-if="formData.recordList.length" class="record_list">
          <div v-for="(item, i) in formData.recordList" class="record_item" :key="i">
            <div class="item_left">
              <a-tag v-if="item.status == -1" color="#909399" size="large">撤回</a-tag>
              <a-tag v-else-if="item.status == 0" color="#409eff" size="large">待审核</a-tag>
              <a-tag v-else-if="item.status == 1" color="#67C23A" size="large">通过</a-tag>
              <a-tag v-else-if="item.status == 2" color="#F56C6C" size="large">不通过</a-tag>
            </div>

            <div v-if="item.fileUrl" style="margin-top: -10px">
              <PreviewFileList :list="[item.fileUrl]" />
            </div>

            <div class="item_right">
              <div class="name">审核人：{{ item.auditUserName }}</div>
              <div class="time">{{ item.auditTime }}</div>
              <div class="desc">{{ item.comment }}</div>

              <!-- <div v-if="item.fileUrl" class="attachment">
                <a-button type="link" @click="handlePreview(item)">
                  <a-icon type="paper-clip" />
                  查看附件
                </a-button>
              </div> -->
            </div>
          </div>
        </div>
        <a-empty v-else />
      </a-spin>
      <template #footer>
        <a-button @click="close"> 关 闭 </a-button>
      </template>
    </a-modal>

    <!-- 预览文件列表-弹框组件 -->
    <!-- <PreviewFileListModal ref="previewFileListModalRef" /> -->
  </div>
</template>

<script>
import * as materialApi from '@/api/material.api'
// import PreviewFileListModal from '../previewFileListModal/index.vue'
import PreviewFileList from '../previewFileList/index.vue'
/**
 * 初始化表单（提交）数据
 */
const initFormData = () => {
  return {
    planId: null,
    recordList: [
      // {
      //   id: 0,
      //   fileId: '',
      //   // 图片
      //   fileUrl:
      //     'https://qadn-test-1256017579.cos.ap-guangzhou.myqcloud.com/crm/dsp/web/1724120279416_activity_98516c6b169a4cef88f4947cbab2698-copy.png',
      //   // 视频
      //   // fileUrl: 'https://test-mall-video.oss-cn-zhangjiakou.aliyuncs.com/product_d997233b04a14460bebcc6bb7988b300',
      //   // 音频
      //   // fileUrl: '',
      //   comment:
      //     '审核核核核核核核核核核核核核核核核核核核核核核核核核核核核核核核核核核核核核核核核核核核核核核核核核核核核核核核核核通过',
      //   //  状态：-1:撤回, 0:待审核, 1:通过, 2:不通过
      //   status: 0,
      //   auditUserName: '张大幅',
      //   auditTime: '2025-03-05'
      // }
    ]
  }
}

export default {
  name: 'materialAuditRecordModal',
  components: {
    // PreviewFileListModal,
    PreviewFileList
  },
  emits: ['afterClose'],
  props: {},
  data() {
    return {
      visible: false,
      loading: false,
      formData: initFormData()
    }
  },

  methods: {
    handlePreview({ fileUrl = '' }) {
      this.$refs.previewFileListModalRef &&
        this.$refs.previewFileListModalRef.open([
          fileUrl,
          'https://qadn-test-1256017579.cos.ap-guangzhou.myqcloud.com/crm/dsp/web/1724161201483_ff2ace1c6608de9fe393dbf88ad6255b.mp4',
          'https://qinlin-doorbell.oss-cn-zhangjiakou.aliyuncs.com/wav_0440ba3c199f4134983d62a682f2d99e.wav',
          'https://test-mall-video.oss-cn-zhangjiakou.aliyuncs.com/product_d997233b04a14460bebcc6bb7988b300'
        ])
    },

    /**
     * 查询素材审核记录（H5审核）
     */
    async listAuditRecords() {
      try {
        const res = await materialApi.listAuditRecords({ planId: this.formData.planId })
        const { code, msg, data } = res.data || {}
        if (code !== 200) return this.$message.error(msg)
        this.formData.recordList = data || []
      } catch (err) {
        console.error('listAuditRecords error:', err)
      }
    },

    /**
     * 重置数据
     */
    afterClose() {
      this.loading = false
      this.formData = initFormData()
      this.$emit('afterClose')
    },

    /**
     * 打开弹窗
     */
    open(planId) {
      if (this.visible) return
      this.visible = true
      if (planId) {
        this.formData.planId = planId
        this.listAuditRecords()
      }
    },

    /**
     * 关闭弹窗
     */
    close() {
      if (!this.visible) return
      this.visible = false
    }
  },

  mounted() {},

  beforeDestroy() {}
}
</script>

<style lang="scss" scoped>
.record_list {
  .record_item {
    display: flex;
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  .item_left {
    // display: flex;
    // align-items: center;
    /deep/ .ant-tag {
      font-size: 14px;
      padding: 0 12px;
      height: 32px;
      line-height: 32px;
      margin-right: 10px;
    }
  }

  .item_right {
    flex: 1;
    overflow: hidden;
    margin-left: 10px;
    .name {
      font-size: 16px;
      font-weight: 600;
      line-height: 32px;
    }
    .time {
      font-size: 14px;
      color: #999;
      line-height: 24px;
    }
    .desc {
      margin-top: 10px;
      font-size: 14px;
      color: #333;
      line-height: 22px;
    }
    .attachment {
      margin-top: 10px;
      .icon {
        color: #409eff;
      }
    }
    .report_info {
      margin-top: 10px;
      .title {
        font-size: 14px;
        font-weight: 600;
        line-height: 24px;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
